(function () {
  var top = document.querySelector('.top'), hero = document.querySelector('.hero');
  function solida() { if (top) top.classList.toggle('is-solida', !hero || window.scrollY > (hero.offsetHeight - 120)); }
  solida(); window.addEventListener('scroll', solida, { passive: true });
  var menu = document.querySelector('.top__menu'), nav = document.querySelector('.top nav');
  if (menu && nav) menu.addEventListener('click', function () {
    var a = nav.classList.toggle('is-abierto'); menu.setAttribute('aria-expanded', a); menu.textContent = a ? 'Cerrar' : 'Menú';
    if (a) top.classList.add('is-solida'); else solida();
  });
  var rv = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-v'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else rv.forEach(function (el) { el.classList.add('is-v'); });
  var main = document.querySelector('.ficha__main img');
  document.querySelectorAll('.ficha__thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.ficha__thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true'); main.src = b.dataset.src; main.className = b.classList.contains('es-botella') ? 'es-botella' : '';
    });
  });
  document.querySelectorAll('.cant').forEach(function (c) {
    var i = c.querySelector('input');
    c.addEventListener('click', function (e) { if (e.target.tagName !== 'BUTTON') return; e.preventDefault(); i.value = Math.max(1, Math.min(24, (+i.value || 1) + (+e.target.dataset.d))); });
  });
})();
